import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import RegistroDetalle from "components/logins/registroDetalle";
const ModalDetalles = ({ show, handleClose, tabla }) => {
  return (
    <Modal show={show.show_} fullscreen={true} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Registro</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <RegistroDetalle Isadmin={true} id={show.id} close={handleClose} tabla={tabla} />
     
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDetalles;
